export const queryKeys = {
  categories: {
    all: ['categories'],
    byId: (id) => [...queryKeys.categories.all, id],
    list: (filters) => [...queryKeys.categories.all, { filters }],
  },
  cards: {
    all: ['cards'],
    byId: (id) => [...queryKeys.cards.all, id],
    list: (filters) => [...queryKeys.cards.all, { filters }],
    trending: (categoryId) => ['cards', 'trending', categoryId],
    justIn: (categoryId) => ['cards', 'justIn', categoryId],
    launched: (categoryId) => ['cards', 'launched', categoryId],
    mostPopular: () => ['cards', 'mostPopular'],
    byCategory: (categoryId) => [...queryKeys.cards.all, 'category', categoryId],
    byCompanyOverview: (companyOverviewId) => [...queryKeys.cards.all, 'companyOverview', companyOverviewId],
  },
  company: {
    all: ['company'],
    byId: (id) => [...queryKeys.company.all, id],
    bySlug: (slug) => [...queryKeys.company.all, { slug }],
    overview: (id) => [...queryKeys.company.all, 'overview', id],
  },
  assets: {
    all: ['assets'],
    byId: (id) => [...queryKeys.assets.all, id],
    byType: (type) => [...queryKeys.assets.all, { type }],
  },
  videoPreview: {
    all: ['videoPreview'],
    byId: (companyId, size) => [...queryKeys.videoPreview.all, companyId, size],
    list: (filters) => [...queryKeys.videoPreview.all, { filters }],
  },
  footer: {
    all: ['footer'],
    cardCompany: ['footer', 'cardCompany'],
  },
  ticker: {
    all: ['ticker'],
    byId: (id) => [...queryKeys.ticker.all, id],
  }
};